//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant';
import headTop from '../../components/headTop'
export default {
    components: {
        headTop
    },
    data () {
        return {
            boxItem:[],
            typeId:"",
            // pageModel:{pageSize:0},
            model:{pageNumber:0},
            loading: false,
            finished: false,
            typeId:"",
            typeName:"",


        }
    },
     created(){
        this.typeId=this.$route.query.typeId
        this.typeName=this.$route.query.typeName
        // this.init()
        this.onLoad()
    },
    methods: {
         init(){
            this.model.typeId=this.typeId;
            this.model.pageNumber=1;

            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/initArticleList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      console.log(res.body)
                      this.boxItem=res.body.rows
                    }
                },function(res){
            });
        },
       detail(newsId){
             window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+this.typeId+"&typeName="+this.typeName
       },
        onLoad() {
      // 异步更新数据
      setTimeout(() => {
           this.model.typeId=this.typeId;
           this.model.pageNumber=this.model.pageNumber+1;
           this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/initArticleList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                        this.boxItem=this.boxItem.concat(res.body.rows)
                        console.log("this.boxItem"+this.boxItem.length)
                  // 加载状态结束
                    this.loading = false;
                   // 数据全部加载完成

                    if (this.boxItem.length >= res.body.total) {
                            this.finished = true;
                        }
                    //  if (this.model.pageNumber >= res.body.pageCount) {
                    //          this.finished = true;
                    //     }
                    }
                },function(res){
                    console.log(res.status);
            });
      }, 500);
    },
    }
}



// WEBPACK FOOTER //
// ./src/views/consult/sharelist.vue